import { defaultSettings } from "src/components/settings"

// ----------------------------------------------------------------------

export const schemeConfig = {
    modeStorageKey: "theme-modes",
    defaultMode: defaultSettings.colorScheme,
}
